import { Box } from "@mui/material";

import { ServiceRequest } from "../../../../types/service.type";
import ServiceReviews from "../../../../components/ServiceReviews";
import ServiceUserDetails from "../../../../components/ServiceUserDetails";
import ServiceDescription from "../../../../components/ServiceDescription";
import ServiceAvailability from "../../../../components/ServiceAvailability";
import { useServiceRequestProfile } from "../../../../hooks/useServiceRequestProfile";

const DetailsTab = ({
  serviceRequest,
  isServiceRequestLoading,
}: {
  serviceRequest?: ServiceRequest;
  isServiceRequestLoading: boolean;
}) => {
  const { service } = serviceRequest || {};
  const {
    userToShow,
    rating,
    reviewsCount,
    completedJobs,
    isLoading: isServiceProfileLoading,
    isCurrentUserRequester,
    isCurrentUserProvider,
  } = useServiceRequestProfile(serviceRequest);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <ServiceDescription service={serviceRequest?.service} isServiceLoading={isServiceRequestLoading} />
      <ServiceAvailability availability={service?.availability} isLoading={isServiceRequestLoading} />
      <ServiceUserDetails
        rating={rating}
        reviewsCount={reviewsCount}
        completedJobs={completedJobs}
        user={userToShow!}
        isLoading={isServiceProfileLoading}
        isCurrentUserRequester={isCurrentUserRequester}
      />
      <ServiceReviews
        serviceId={service?.id}
        userId={userToShow?.id}
        isServiceLoading={isServiceRequestLoading}
        isCurrentUserProvider={isCurrentUserProvider}
      />
    </Box>
  );
};

export default DetailsTab;
